(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5075);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ preventDefault; }
/* harmony export */ });
function preventDefault(e) {
    e === null || e === void 0 ? void 0 : e.stopPropagation();
    if (e && e.preventDefault) {
        e.preventDefault();
    }
}


/***/ }),

/***/ 55308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var components_Logo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65120);



var AuthFormContainer = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("main", {
        className: "justify-content-center align-items-center d-flex min-vh-100 py-4 w-100",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
            style: {
                minWidth: 450
            },
            className: "rounded shadow-2 col-4 d-flex flex-column gap-4 bg-white px-4 px-lg-6 py-8",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                    className: "text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(components_Logo__WEBPACK_IMPORTED_MODULE_2__/* .LogoSVG */ .f, {
                        height: 100,
                        width: 100
                    })
                }),
                children
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AuthFormContainer);


/***/ }),

/***/ 14510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74231);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81305);
/* harmony import */ var components_base_forms_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41280);
/* harmony import */ var components_base_forms_InputGroup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91263);
/* harmony import */ var common_services_useUser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99195);
/* harmony import */ var components_base_Messages__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56884);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var common_utils_forms_preventDefault__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(12922);
/* harmony import */ var components_page_AuthFormContainer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55308);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);













var schema = yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry().shape({
    email: yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_().email("Email must be valid").required("Email address is required"),
    password: yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_().required("Password is required")
});
var Login = function(param) {
    var error = param.error, message = param.message;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,common_services_useUser__WEBPACK_IMPORTED_MODULE_5__/* .useLoginMutation */ .YA)(), 2), login = ref[0], ref1 = ref[1], data = ref1.data, userError = ref1.error, userLoading = ref1.isLoading;
    var ref2 = (0,formik__WEBPACK_IMPORTED_MODULE_2__/* .useFormik */ .TA)({
        initialValues: {
            email: "",
            password: ""
        },
        onSubmit: function() {
            login((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, values)).then(function(e) {
                if (!e.error) {
                    var ref;
                    router.replace("/auth/otp?email=".concat(encodeURIComponent(values.email), "&token=").concat((ref = e.data) === null || ref === void 0 ? void 0 : ref.token));
                }
            });
        },
        validateOnMount: true,
        validationSchema: schema
    }), errors = ref2.errors, handleBlur = ref2.handleBlur, handleChange = ref2.handleChange, handleSubmit = ref2.handleSubmit, setTouched = ref2.setTouched, values = ref2.values;
    // useEffect(() => {
    //   console.log(userError)
    //   tryConfirmEmailRedirect(userError)
    // }, [userError])
    var onSubmit = function(e) {
        (0,common_utils_forms_preventDefault__WEBPACK_IMPORTED_MODULE_12__/* .preventDefault */ .P)(e);
        var newTouched = {};
        Object.keys(errors).map(function(v) {
            // @ts-ignore
            newTouched[v] = true;
        });
        setTouched(newTouched);
        handleSubmit(e);
    };
    var changeHandler = function(e) {
        handleChange(e);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(components_page_AuthFormContainer__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("form", {
            className: "d-flex flex-column gap-4",
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(components_base_Messages__WEBPACK_IMPORTED_MODULE_6__/* .SuccessMessage */ .kk, {
                    children: message
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(components_base_forms_InputGroup__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    title: "Email Address",
                    name: "email",
                    type: "email",
                    onChange: changeHandler,
                    onBlur: handleBlur,
                    value: values.email,
                    isValid: !errors.email
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(components_base_forms_InputGroup__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    title: "Password",
                    type: "password",
                    name: "password",
                    onChange: changeHandler,
                    onBlur: handleBlur,
                    value: values.password,
                    isValid: !errors.password
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(components_base_Messages__WEBPACK_IMPORTED_MODULE_6__/* .ErrorMessage */ .Bc, {
                    children: error || userError
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                        href: "/auth/forgot-password",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
                            href: "/auth/forgot-password",
                            children: "Forgot your password?"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(components_base_forms_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    className: "w-100",
                    disabled: userLoading || !!data,
                    type: "submit",
                    children: "Sign in"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Login);


/***/ }),

/***/ 5075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51351);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var project_polyfill__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75435);
/* harmony import */ var common_services_useUser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99195);
/* harmony import */ var components_project_SubscriptionTable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53761);
/* harmony import */ var _examples_auth_Login__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14510);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _app__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40551);








var HomePage = function(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    var data = (0,common_services_useUser__WEBPACK_IMPORTED_MODULE_2__/* .useUser */ .aF)({}).data;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    if (!data) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_examples_auth_Login__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    } else {
        if (router.query.redirect) {
            router.replace("".concat(router.query.redirect));
            return null;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: "container-fluid page-container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(components_project_SubscriptionTable__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
        });
    }
};
HomePage.getLayout = function(page, pageProps, user) {
    if (user) {
        return (0,_app__WEBPACK_IMPORTED_MODULE_6__.defaultLayout)(page);
    }
    return page;
};
/* harmony default export */ __webpack_exports__["default"] = (HomePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [260,762,795,53,191,569,949,654,915,579,761,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);